import axios from 'axios'
import { authHeader } from '../util/authHeader'

import baseClaimForm from '@/mixins/baseClaimForm'
import state from '@/mixins/state'
import base from '@/mixins/base'

import { mapActions, mapGetters } from 'vuex'

const MSG_TYPE_INITIAL = 0; const MSG_TYPE_INFO = 1; const MSG_TYPE_ERROR = 2

export default {
  mixins: [
    base,
    baseClaimForm,
    state
  ],
  components: {

  },
  data () {
    return {

      insuranceLineType: 2,

      apiUserMsg: null,

      apiMsg: {
        type: MSG_TYPE_INITIAL,
        text: ''
      },

      //overrideClaimFormSaveMsg: 'You claim form has been saved.  To resume this claim form you will need to remember the policy, email, date of birth and postcode you have entered!'
      overrideClaimFormSaveMsg: 'Your claim form has been saved, you can now close your browser.  To resume this claim form you need to remember the policy number, email, date of birth and postcode you have entered; or to continue now, click next.'
    }
  },
  mounted () {
    if (this.claimForm.formReference === '') { this.setClaimFormReference({ formReference: this.newId() }) }

    if (this.claimForm.insuranceLine === '') { this.setInsuranceLine({ insuranceLine: this.insuranceLineType }) }
  },
  // beforeRouteUpdate (to, from, next) {
  //   this.autoSaveClaimForm()
  //   next()
  // },
  beforeRouteLeave (to, from, next) {
    this.autoSaveClaimForm()
    next()
  },
  computed: {
    // ---------------------------------------------------------//
    // Urls for this flavour of claim form
    // ---------------------------------------------------------//
    saveClaimFormUrl () {
      return this.baseUrl + '/api/v1/onlineclaim/tiga/partial'
    },
    submitClaimFormUrl () {
      return this.baseUrl + '/api/v1/onlineclaim/tiga/submit/'
    },
    ...mapGetters({
      deviceTypes: 'gadget/deviceTypes',
      deviceMakes: 'gadget/deviceMakes',
      deviceMakesLoading: 'gadget/deviceMakesLoading',
      deviceModels: 'gadget/deviceModels',
      deviceModelsLoading: 'gadget/deviceModelsLoading',
      deviceMakeById: 'gadget/deviceMakeLabelById',
      deviceModelById: 'gadget/deviceModelLabelById',
      getReseller: 'reseller/getResellerInfo',
      underwriter: 'claimform/getUnderwriter'
    }),
    formLeadTitle () {
      return this.$textManager.getText("formLeadTitle", this.$route.name)
    }
  },
  methods: {
    // ---------------------------------------------------------//
    // Get the policy details from the server
    // ---------------------------------------------------------//
    lookupPolicy (number, dob, postcode, successPath) {
      this.isLoading = true

      let payload = {
        resellerId: this.resellerId,
        policyNumber: number,
        policyholderDOB: dob,
        policyholderPostcode: postcode
      }
      // axios.get( this.baseUrl + '/api/v1/standalonepolicy/' + number)
      axios.post(this.baseUrl + '/api/v1/tigapolicy/getpolicyincredirect', payload)
        .then(response => {
          let apiRes = response.data
          if (apiRes.data) {
            let redirect = apiRes.data.portalRedirect
            if (redirect != null) {
              // redirect
              this.redirectUrl = redirect
              this.policyRedirect()
            }
            this.setStandalonePolicy2({ ...apiRes.data.policy })
            this.getUnderwriter(apiRes.data.policy.underwriterId)
            this.setPolicy({ number: apiRes.data.policy.number })
            if (successPath) {
              this.$router.push(successPath)
            }
          } else {
            this.setPolicy({ number: payload.policyNumber })

            if (successPath) {
              this.$router.push(successPath)
            }
          }
        })
        .catch((error) => {   
          console.log(error);      
          this.apiMsg = {
            type: MSG_TYPE_ERROR,
            text: 'There seems to be a problem.  Please try again later.'
          }
        })
        .finally(() => { this.isLoading = false })
    },
    // ---------------------------------------------------------//
    // Saves the claim form object (server)
    // ---------------------------------------------------------//
    autoSaveClaimForm () {
      try {
        axios
          .post(this.saveClaimFormUrl, this.buildClaimForm(), { headers: authHeader() })
          .then(response => {
            if (response.data) {
              // this.savedClaimForm = apiRes.data
            }
          })
          // .catch(error => { })
          .finally(() => { this.isLoading = false })

      } catch (error) {
        
      }
    },

    // ---------------------------------------------------------//
    // Get the policy details from the server
    // ---------------------------------------------------------//
    resumeSavedForm (email, number, dob, postcode, successPath) {
      this.isLoading = true

      let payload = {
        email,
        policy: number,
        dob,
        postcode
      }

      axios.post(this.baseUrl + '/api/v1/onlineclaim/tiga/resume', payload)
        .then(response => {
          let { data, messages } = response.data

          if (data) {
            // load form
            
            this.setInProgressForm(data)
            
            if (successPath) {
              this.$router.push(successPath)
            }
          }

          if (messages) {
            // what went wrong / messages
          }
        })
        .catch(() => {
          this.apiMsg = {
            type: MSG_TYPE_ERROR,
            text: 'There seems to be a problem.  Please try again later.'
          }
        })
        .finally(() => { this.isLoading = false })
    },

    // ---------------------------------------------------------//
    // Submits the completed claim form object (server)
    // ---------------------------------------------------------//
    submitClaimForm () {
      this.isLoading = true

      axios
        .post(this.submitClaimFormUrl, this.buildClaimForm(), { headers: authHeader() })
        .then(response => {
          if (response.data) {
            let { data, messages } = response.data

            if (messages && messages.length > 0) {
              
            } else {
              
              let { claimReference, passed, otCode, claimId, gadgetId } = data

              let incidentType = this.selectedIncidentTypeL1

              this.setSubmissionResponse({
                claimReference: claimReference,
                approved: passed,
                otCode: otCode,
                claimId: claimId,
                gadgetId: gadgetId,
                incidentType: incidentType //  HACK!
              })

              this.$store.commit('claimform/reset')

              this.setSubmissionResponse({
                claimReference: claimReference,
                approved: passed,
                otCode: otCode,
                claimId: claimId,
                gadgetId: gadgetId,
                incidentType: incidentType //  HACK!
              })

              this.$router.push({ path: 'thankyou' })
            }
          }
        })

        .finally(() => { this.isLoading = false })
    },
    ...mapActions({
      fetchDeviceTypes: 'gadget/fetchDeviceTypes',
      fetchDeviceMakes: 'gadget/fetchDeviceMakes',
      fetchDeviceModels: 'gadget/fetchDeviceModels',
      resetDeviceMakes: 'gadget/resetDeviceMakes',
      resetDeviceModels: 'gadget/resetDeviceModels'
    })
  }
}
